import { render, staticRenderFns } from "./pc-richtext.vue?vue&type=template&id=199523a0&"
import script from "./pc-richtext.vue?vue&type=script&lang=ts&"
export * from "./pc-richtext.vue?vue&type=script&lang=ts&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./pc-richtext.vue?vue&type=style&index=1&id=199523a0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports